import { render } from "./InfoGridRank112.vue?vue&type=template&id=19318a84&scoped=true"
import script from "./InfoGridRank112.vue?vue&type=script&lang=js"
export * from "./InfoGridRank112.vue?vue&type=script&lang=js"

import "./InfoGridRank112.vue?vue&type=style&index=0&id=19318a84&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19318a84"]])

export default __exports__